import { render } from "./packet_report.vue?vue&type=template&id=089a0253&scoped=true"
import script from "./packet_report.vue?vue&type=script&lang=js"
export * from "./packet_report.vue?vue&type=script&lang=js"

import "./packet_report.vue?vue&type=style&index=0&id=089a0253&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089a0253"]])

export default __exports__